module.exports = __webpack_public_path__ + "static/media/tugrulAnsay.07ca9e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/tugrulAnsay.jpg
// module id = 1700
// module chunks = 1